module.exports = __webpack_public_path__ + "static/img/head.995bc98b.png";